import { render, staticRenderFns } from "./form-register.vue?vue&type=template&id=c7272000&scoped=true&"
import script from "./form-register.ts?vue&type=script&lang=ts&"
export * from "./form-register.ts?vue&type=script&lang=ts&"
import style0 from "./form-register.scss?vue&type=style&index=0&id=c7272000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7272000",
  null
  
)

export default component.exports